import React from 'react';
import {
	checkTimeslotHasResources,
	checkTimeslotHasBadge,
	preventDefaultDrag,
} from '../../../Utils/utils';

import AttachFileIcon from '@material-ui/icons/AttachFile';
import PollOutlinedIcon from '@material-ui/icons/PollOutlined';
import MovieIcon from '@material-ui/icons/Movie';
import { ReactComponent as BadgeIconBlue } from '../../../Images/svg/badge-blue.svg';
import { ReactComponent as BadgeIconWhite } from '../../../Images/svg/badge-white.svg';
import './AuditoriumSideButtons.scss';

const formatBadgeDate = (iso) => {
	if (!iso) return '';
	const d = new Date(iso);
	const dd = String(d.getDate()).padStart(2, '0');
	const mm = String(d.getMonth() + 1).padStart(2, '0');
	const yyyy = d.getFullYear();
	return `${dd}.${mm}.${yyyy}`;
};

class AuditoriumSideButtons extends React.Component {
	render() {
		const {
			timeSlot,
			translation,
			defaultTranslation,
			hasOnDemandVideos,
			currentTab,
			hasPolls,
			badgeForCurrentTimeslot,
			onGoToCredentials,
		} = this.props;

		const timeslotHasResources = checkTimeslotHasResources(timeSlot);
		const timeslotHasBadge = checkTimeslotHasBadge(timeSlot);
		const userHasBadgeForTimeslot = !!badgeForCurrentTimeslot;

		return (
			<div onDragStart={preventDefaultDrag} className="side-buttons-outer">
				<div onDragStart={preventDefaultDrag} className="side-buttons-middle">
					<div onDragStart={preventDefaultDrag} className="side-buttons-inner">
						{timeSlot && (
							<div
								onClick={this.props.handleChangeTab('polls')}
								className={`side-button-container ${hasPolls ? 'animate-in' : 'animate-out'} ${
									currentTab === 'polls' ? 'active' : ''
								}`}
							>
								<span>
									{translation?.polls?.polls ||
										defaultTranslation?.polls?.polls}
								</span>
								<PollOutlinedIcon />
							</div>
						)}
						{timeslotHasResources && (
							<div
								onClick={this.props.handleChangeTab('resources')}
								className={`side-button-container ${currentTab === 'resources' ? 'active' : ''}`}
							>
								<span>{translation?.auditorium.resourcesButton}</span>
								<AttachFileIcon />
							</div>
						)}
						{hasOnDemandVideos && (
							<div
								onClick={this.props.handleChangeTab('onDemand')}
								className={`side-button-container second-color ${
									currentTab === 'onDemand' ? 'active' : ''
								}`}
							>
								<span>
									{translation?.auditorium.onDemandButton || 'ON-DEMAND'}
								</span>
								<MovieIcon />
							</div>
						)}
						{timeslotHasBadge && (
							<div
								onClick={
									userHasBadgeForTimeslot && onGoToCredentials
										? () => onGoToCredentials()
										: () => this.props.toggleBadgeDialog()
								}
								className={
									userHasBadgeForTimeslot
										? 'side-button-container-badge-owned'
										: 'side-button-container-badge'
								}
							>
								<span>
									{userHasBadgeForTimeslot &&
									badgeForCurrentTimeslot?.purchasedAt ? (
										<>
											<div className="badge-label">
												{translation?.auditorium.badgeButton || 'BADGE'}
											</div>
											<div className="badge-date">
												{formatBadgeDate(badgeForCurrentTimeslot.purchasedAt)}
											</div>
										</>
									) : (
										translation?.auditorium.badgeButton || 'BADGE'
									)}
								</span>
								{userHasBadgeForTimeslot ? (
									<BadgeIconBlue />
								) : (
									<BadgeIconWhite />
								)}
							</div>
						)}
					</div>
				</div>
			</div>
		);
	}
}

export default AuditoriumSideButtons;
